<template>
  <div id="Settings__page">
    <h2 style="text-align: center;">{{$t('NIP field for company search')}}</h2>
    <br />
    <div style="text-align:center">
      <a-select
        style="width:40%"
        @change="handleChangeSearchField"
      >
        <a-select-option v-for="i in allOptionCompanyFields" :key="i.id">{{ i.name }}</a-select-option>
      </a-select>
    </div>
    <br />
    <h2 style="text-align: center;">{{$t('Save type for company data')}}</h2>
    <a-form layout="inline" style="display: flex;justify-content: space-evenly;margin-top:20px">
      <a-form-item style="margin-right: 0;" :label="$t('Requisites')">
        <a-switch
          size="large"
          v-model="saveCompanyTypeNip.Requisites"
          :disabled="!saveCompanyTypeNip.Fields"
          @change="onChange"
        />
      </a-form-item>
      <a-form-item style="margin-right: 0;" :label="$t('Fields')">
        <a-switch
          size="large"
          v-model="saveCompanyTypeNip.Fields"
          :disabled="!saveCompanyTypeNip.Requisites"
          @change="onChange"
        />
      </a-form-item>
    </a-form>
    <UserFieldsTable
      v-if="saveCompanyTypeNip.Fields"
      :allOptionCompanyFields="allOptionCompanyFields"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserFieldsTable from "@/components/integrationNip/UserFieldsTable";

export default {
  components: {
    UserFieldsTable,
  },
  data() {
    return {
      allOptionCompanyFields: [],
    };
  },
  computed: mapGetters(["saveCompanyTypeNip", "companyFieldForNIP"]),
  mounted() {
    BX24.callMethod("crm.company.fields", {}, (result) => {
      var types = ["string", "address", "double"];
      var fieldsList = result.data();
      for (let f in fieldsList) {
        if (fieldsList[f].listLabel && types.includes(fieldsList[f]["type"])) {
          this.allOptionCompanyFields.push({
            id: f,
            name: fieldsList[f]["listLabel"],
          });
        }
      }

    });
    this.resizeWindow();
  },
  updated() {
    this.resizeWindow();
  },
  methods: {
    handleChangeSearchField(value) {
      this.BXsetCompanyFieldForNIPApp(value);
    },
    onChange() {
      this.BXsetCompanySaveTypeApp(this.saveCompanyTypeNip);
    },
    ...mapActions([
      "BXsetCompanySaveTypeApp",
      "resizeWindow",
      "BXsetCompanyFieldForNIPApp",
    ]),
  },
};
</script>

<style scoped>
.col_text {
  text-align: center;
}
</style>